@if (actionParams && actionResults) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="actionParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'name', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="name" [formControlName]="'name'" placeholder="Enter a name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="description" [formControlName]="'description'" placeholder="Enter a description"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Variable Name </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'variableName', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="variableName" [formControlName]="'variableName'" placeholder="Enter variable"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Pattern </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'pattern', myForm: actionParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="actionParams" id="pattern" [formControlName]="'pattern'" placeholder="Enter Number Format Pattern"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Group Separator </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'groupSeparator'"></app-cms>
              <label class="control-optional">Optional</label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'groupSeparator', myForm: actionParams}">
            </ng-container>
            <mat-select activeForm [activeForm]="actionParams" [formControlName]="'groupSeparator'" class="control-dropdown" hideSingleSelectionIndicator>
              <div class="custom-separator_content">
                <input #inputSeparator   id="groupSeparator"  class="custom-separator_input" type="text"
                  placeholder="Add custom separator" (keydown.space)="$event.stopPropagation()"
                                   (keydown.enter)="addSeparator($event, inputSeparator.value);
                                   inputSeparator.value = ''"/>
                            <button class="custom-separator_btn" (click)=" addSeparator($event, inputSeparator.value);
                                     inputSeparator.value = ''">
                  </button>
                </div>
                @for (option of groupSeparatorList; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <ng-container [formGroup]="actionResults">
            <div class="control-div logic-div">
              <div class="logic-item-title logic-item-success">Success</div>
              <ng-container *ngTemplateOutlet="next; context: { controlName: 'success', form: actionResults}">
              </ng-container>
            </div>
            <div class="control-div logic-div">
              <div class="logic-item-title logic-item-error">Error</div>
              <ng-container *ngTemplateOutlet="next; context: { controlName: 'error', form: actionResults}">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
    </div>
  }

  <ng-template #next let-controlName="controlName" let-form="form">
    <label class="point-to-label">
      Point To
      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
    </label>
    @if (nodeFlowDetails) {
      <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
        [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
        [name]="controlName"
        [form]="form"
        [stepId]="nodeFlowDetails.stepId">
      ></next-selector>
    }
  </ng-template>


  <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
    @if (myForm.controls[myControlName]; as control) {
      @if (control.invalid && (control.dirty || control.touched)) {
        <div class="validationField">
          @for (error of control.errors | keyvalue; track error) {
            <div>
              <span class="fa fa-exclamation-circle"></span>
              <span [id]="'validationField-' + myControlName">
                {{error.value}}
              </span>
            </div>
          }
        </div>
      }
    }
  </ng-template>